import { type FC } from 'react';

import { type BoxProps, Center, useControllableState } from '@chakra-ui/react';

import { IconMaximize, IconMinimize } from '../Icons';

type VideoCollapserProps = {
  outsideIsCollapsed?: boolean;
  setOutsideIsCollapsed?: (isCollapsed: boolean) => void;
  styles?: BoxProps;
};

export const VideoCollapser: FC<VideoCollapserProps> = ({
  outsideIsCollapsed,
  setOutsideIsCollapsed,
  styles = {},
}) => {
  const [isCollapsed, setIsCollapsed] = useControllableState<boolean>({
    value: outsideIsCollapsed,
    defaultValue: false,
    onChange: setOutsideIsCollapsed,
  });

  const handleClick = () => {
    setIsCollapsed((prev) => !prev);
  };

  return (
    <Center
      pos="absolute"
      top={3}
      right={3}
      rounded="full"
      bg="black"
      opacity={0.6}
      w="44px"
      h="44px"
      cursor="pointer"
      onClick={handleClick}
      zIndex={1}
      {...styles}
    >
      {isCollapsed ? (
        <IconMaximize fontSize="20px" />
      ) : (
        <IconMinimize fontSize="20px" />
      )}
    </Center>
  );
};
